var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-wide-a terms_layer showing"},[_c('div',{staticClass:"layer_section-container"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"align-box size-auto"},[_c('button',{staticClass:"btn-modal_close",attrs:{"type":"button"},on:{"click":_vm.onDispose}},[_vm._v("\n        닫기\n      ")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38104258","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-popups/PopupTerms.vue
// module id = null
// module chunks = 